const isBrowser = typeof window !== 'undefined';
const _protocol = isBrowser ? window.location.protocol : 'http:';
const _hostname = isBrowser ? window.location.hostname : 'localhost';
const _wsProto  = _protocol === 'https:' ? 'wss:' : 'ws:';

const isLocalhost = _hostname === 'localhost' || _hostname === '127.0.0.1' || _hostname === '0.0.0.0';

// Clean configured environment variable if provided
const rawEnvApi = (process.env.REACT_APP_API_URL || '').replace('/api/v1', '').replace(/\/$/, '');

// Determine the API base URL:
// 1. If running on a remote/production domain (e.g. astravision.astrawinindia.com), ALWAYS use current origin so Nginx handles /api/
//    and NEVER leak 127.0.0.1/localhost into production client browsers.
// 2. If running on localhost and an explicit REACT_APP_API_URL is configured, use it.
// 3. Fallback for localhost development: http://localhost:8000
const getApiBase = (): string => {
  if (isBrowser && !isLocalhost) {
    if (rawEnvApi && !rawEnvApi.includes('127.0.0.1') && !rawEnvApi.includes('localhost')) {
      return rawEnvApi;
    }
    return window.location.origin;
  }
  return rawEnvApi || `${_protocol}//${_hostname}:8000`;
};

export const API_BASE: string = getApiBase();

// WebSocket base — derived from API_BASE so it always matches the same host/port and protocol
export const WS_BASE: string = API_BASE
  ? API_BASE.replace(/^https:/, 'wss:').replace(/^http:/, 'ws:')
  : `${_wsProto}//${isBrowser ? window.location.host : 'localhost:8000'}`;
